import { chain, find } from 'lodash';
import { AGGREGATORS, CHART_AGGREGATORS, CHART_TYPE, DS_ID } from 'src/constants/chart';

export default function dsAssessmentData() {
  return {
    id: DS_ID.ASSESSMENT,
    label: this.$t('insights.chartConfigurator.sourcesAssessmentDataLabel'),
    hasDateRange: false,

    availableFilters: ['assessmentTypes'],
    groupByOptions: [
      {
        label: this.$t('insights.chartConfigurator.groupByNoGroupLabel'),
        value: null,
        seriesLabelFrom: null,
      },
      {
        label: this.$t('insights.chartConfigurator.groupByAdministrationLabel'),
        value: 'assessmentId',
        seriesLabelFrom: 'administrationTitle',
        seriesOrderBy: 'date',
      },
      {
        label: this.$t('insights.chartConfigurator.groupByAssessmentFieldLabel'),
        value: 'fieldId',
        seriesLabelFrom: 'fieldLabel',
        seriesOrderBy: 'fieldOrder',
      },
      {
        seriesLabelFrom: null,

        expand: async (dataSeriesSettings) => {
          if (dataSeriesSettings?.postloadFilter?.assessmentTypes?.assessmentTypeId?.length !== 1) {
            return [];
          }
          const assessmentTypeId = dataSeriesSettings.postloadFilter.assessmentTypes.assessmentTypeId[0];

          if (
            !this.assessmentTypeFields.some(
              (assessmentTypeField) => assessmentTypeField.assessmentType === assessmentTypeId,
            )
          ) {
            await this.getAssessmentFormFields(assessmentTypeId);
          }
          return chain(this.assessmentTypeFields)
            .filter({ isDimension: true })
            .map((field) => {
              const fieldGroup = find(this.assessmentTypeFieldGroups, { id: field.assessmentTypeFieldGroup });
              return {
                value: `dim_${field.id}`,
                label: field.label,
                order: (fieldGroup?.order ?? 0) * 1000 + field.order,
              };
            })
            .sortBy('order')
            .value();
        },
      },
    ],
    xAxes: [
      {
        id: 'xaAssessment',
        label: this.$t('insights.chartConfigurator.xAxisAdministrationLabel'),
        chartType: CHART_TYPE.COLUMN,
        xAxisType: 'category',
        xAxisAggregateBy: 'assessmentId',
        xAxisDataProperty: 'assessmentId',
        xAxisCategoryLabel: 'administrationTitle',
        xAxisTimeUnit: null,
        xAxisOrderBy: 'date',
      },
      {
        id: 'xaAssessmentField',
        label: this.$t('insights.chartConfigurator.xAxisAssessmentFieldLabel'),
        chartType: CHART_TYPE.COLUMN,
        xAxisType: 'category',
        xAxisAggregateBy: 'fieldId',
        xAxisDataProperty: 'fieldId',
        xAxisCategoryLabel: 'fieldLabel',
        xAxisTimeUnit: null,
        xAxisOrderBy: 'fieldOrder',
      },
    ],
    seriesPresets: [
      {
        id: 'spScore',
        label: this.$t('insights.chartConfigurator.seriesScore'),
        dataProperty: 'score',
        aggregator: AGGREGATORS.AVERAGE,
        chartAggregator: CHART_AGGREGATORS.AVERAGE,
        chartType: CHART_TYPE.COLUMN,
        axis: 'number',
        axisCategory: null,
        axisCategoryLabel: null,
        hideColumnInTable: false,
        disableChartTypes: [CHART_TYPE.LOGARITHMIC, CHART_TYPE.SCATTERPLOT],
      },
      {
        id: 'spMinScore',
        label: this.$t('insights.chartConfigurator.seriesMinScore'),
        dataProperty: 'score',
        aggregator: AGGREGATORS.LOW,
        chartAggregator: CHART_AGGREGATORS.LOW,
        chartType: CHART_TYPE.COLUMN,
        axis: 'number',
        axisCategory: null,
        axisCategoryLabel: null,
        hideColumnInTable: false,
        disableChartTypes: [CHART_TYPE.LOGARITHMIC, CHART_TYPE.SCATTERPLOT],
      },
      {
        id: 'spMaxScore',
        label: this.$t('insights.chartConfigurator.seriesMaxScore'),
        dataProperty: 'score',
        aggregator: AGGREGATORS.HIGH,
        chartAggregator: CHART_AGGREGATORS.HIGH,
        chartType: CHART_TYPE.COLUMN,
        axis: 'number',
        axisCategory: null,
        axisCategoryLabel: null,
        hideColumnInTable: false,
        disableChartTypes: [CHART_TYPE.LOGARITHMIC, CHART_TYPE.SCATTERPLOT],
      },
    ],
    tableColumns: [
      {
        name: 'xAxis',
        align: 'left',
        sortable: true,
        visibility: ['assessmentId', 'fieldId'],
        visibilityExport: ['assessmentId', 'fieldId'],
      },
    ],
  };
}
